import { snapToRoads, type RoadSpatialIndex } from "./editor-geom.ts";
import type { LngLat } from "./types.ts";

export type RoadSegment = readonly [LngLat, LngLat];

/** Road magnet for place / grab / merge: needs snap on, a canvas, and extracted roads. */
export function roadSnapPoint(
  at: LngLat,
  roads: readonly RoadSegment[],
  opts: { magnetOn: boolean; hasWorkArea: boolean; radiusM: number; index?: RoadSpatialIndex | null },
): LngLat {
  if (!opts.magnetOn || !opts.hasWorkArea || roads.length === 0) return at;
  return snapToRoads(at, roads, opts.radiusM, opts.index).point;
}
